<template>
  <div class="basic_flod_text_list">
    <div class="tooptipPart all_tooptipPart" >
      <my_edit_btn :module="module"  :title="$t('widgets_basic_article_classification_index_336')" ></my_edit_btn>
      <my_edit_btn  :module="module"  tabName="animation"  :title="$t('widgets_basic_article_classification_edit_330')" v-if="isPc"></my_edit_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index"   :title="$t('widgets_basic_article_list_index_414')"></my_close_btn>
      
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="list-wrap">
      <!-- 自定义文本模式 -->
      <template v-if="listArr.content_type === 'custom'">
        <div class="flod-list" v-for="item in listArr.list" :key="item.id" :class="[active_index.includes(item.id)? 'flod-list-show' :'flod-list-hidden']"
          :style="{
            ...box_shadow(item),...background_style,...borderRadius,...borderRadius,...border_style(item),
            'marginBottom': listArr.list_padding + 'px',
          }">
          <div class="flod_text_title" @click="list_toggle(item)">
            <div class="title-left" :style="{...font_title_style(item)}">{{item.title}}</div>
            <template v-if="listArr.icon_show == 'true'" >
              <img :src="item.icon_before" alt="" class="title-icon title-default" :style="{ width: listArr.icon_width +'px'}" />
              <img :src="item.icon_hover" alt="" class="title-icon title-hover" :style="{ width: listArr.icon_width +'px'}" />
            </template>
          </div>
          <div class="flod_text_content" :class="[active_index.includes(item.id) ? 'flod_content_height_auto': 'flod_content_height_0']" :id="`flod_text_content_${item.id}`">
            <div class="content-text" v-html="item.content"></div>
          </div>
        </div>
      </template>
      <!-- FAQ模式 -->
      <template v-else-if="listArr.content_type === 'faq'">
        <div class="faq-list" v-if="faqList.length > 0">
          <div class="faq-item" :class="{ 'is-active': activeFaqIndex === idx }" v-for="(faq, idx) in faqList" :key="idx">
            <div class="faq-item-title" @click.stop="faqToggle(idx)">
              <span class="faq-question">{{ faq.question }}</span>
              <template v-if="listArr.icon_show == 'true' && listArr.list[0]">
                <img :src="listArr.list[0].icon_before" alt="" class="title-icon title-default" :style="{ width: listArr.icon_width +'px'}" />
                <img :src="listArr.list[0].icon_hover" alt="" class="title-icon title-hover" :style="{ width: listArr.icon_width +'px'}" />
              </template>
              <span v-else class="faq-toggle-icon"></span>
            </div>
            <div class="faq-answer-wrap" :ref="`faqAnswer_${idx}`">
              <div class="faq-answer" v-html="faq.answer"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import {getBoxShadowStyle, getBackground,getBorderRadiusStyle, getBorderStyle, getFontStyle,getSelectFontStyle} from '@/utils/utils'
import {getGoodsEdit, getArticleEdit} from '@/api/app.js'
export default {
  name: 'basic_flod_text_list',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active_index: [],
      activeFaqIndex: -1,
      fetchedFaqList: []
    }
  },
  computed: {
    faqList() {
      // 1. 优先使用从接口获取的真实 FAQ 数据
      if (this.fetchedFaqList.length > 0) {
        return this.fetchedFaqList
      }
      // 2. 其次使用组件内已保存的数据
      if (this.module.data.faqList && this.module.data.faqList.length > 0) {
        return this.module.data.faqList
      }
      // 3. 兜底：返回默认占位提示，确保组件在页面上可见
      return [{ question: 'FAQ内容将从产品/新闻/案例详情页中获取', answer: '', editorId: '' }]
    },
   
    module_infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_infor'];
    },
    isPc() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    editID() {
      return this.module.widgets_id
    },
    infor() {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    pcWidgetsInfor() {
      return this.module.data.pc_widgets_infor
    },
    mbWidgetsInfor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    box_shadow() { // 阴影设置 只有PC端才能有阴影 其他的不存在
      return function (item) {
        return this.active_index.includes(item.id) ? getBoxShadowStyle(this.pcWidgetsInfor.boxShadow, 'hover') : getBoxShadowStyle(this.pcWidgetsInfor.boxShadow)
      }
    },
    background_style() {
      return getBackground(this.pcWidgetsInfor.background, {needDefault:true})
    },
    borderRadius() {
      return getBorderRadiusStyle(this.pcWidgetsInfor.borderRadius, {needDefault:true})
    },
    border_style() {
      return function (item) {
        let detail = {}
        detail = this.active_index.includes(item.id) ? this.border_select_color : {}
        return {
          ...getBorderStyle(this.pcWidgetsInfor.barBorder, {needDefault:true}),
          ...detail
        }
      }
  
    },
    border_select_color() { 

      if (this.pcWidgetsInfor.barBorder.radio_val != 'hidden') {
        let barBorder = this.pcWidgetsInfor.barBorder[this.pcWidgetsInfor.barBorder.radio_val]
        return {
          'borderColor':barBorder.border_select_color
        }
      } else {}
    },
    font_title_style() {
      
      return function (item) {
        
        let func = {
          'getFontStyle': getFontStyle,
          'getSelectFontStyle': getSelectFontStyle
        }
      
        return this.active_index.includes(item.id) ? func['getSelectFontStyle'](this.infor.title_font,{needDefault:true}) : func['getFontStyle'](this.infor.title_font,{needDefault:true})
      }
      // getFontStyle(this.infor.title_font)
    }
  },
  watch: {
    'listArr.content_type'() {
      // 切换到FAQ模式时重新获取数据
      if (this.listArr.content_type === 'faq') {
        this.$nextTick(() => {
          this.initFaqActive()
        })
        this.fetchFaqData()
      } else {
        this.fetchedFaqList = []
        this.activeFaqIndex = -1
      }
    },
    'listArr.list': {
      handler() {
        // 仅自定义模式处理列表高度和激活状态
        if (this.listArr.content_type === 'custom') {
          this.active_index_toggle()
          this.height_set()
        }
      },
      deep: true
    },
    'pcWidgetsInfor.show_type'() {
      if (this.listArr.content_type === 'custom') {
        this.active_index_toggle()
        this.$nextTick(() => {
          this.listArr.list.forEach(item => {
            let dom = document.querySelector(`#flod_text_content_${item.id}`)
            if (dom && dom.classList.contains('flod_content_height_auto')) {
              dom.style.height = `${dom.getAttribute('data-height')}`
            }
          })
        })
      }
    }
  },
  mounted() {
    console.log('[折叠文本列表-index] 组件已加载, widgets_id=', this.editID, ', content_type =', this.listArr.content_type)
    // 仅自定义模式初始化高度和激活状态
    if (this.listArr.content_type === 'custom') {
      this.active_index_toggle()
      this.height_set()
    }
    // FAQ模式：从详情接口获取数据
    if (this.listArr.content_type === 'faq') {
      this.initFaqActive()
      this.fetchFaqData()
    }
   },
  methods: {
    active_index_toggle() {
      if (this.pcWidgetsInfor.show_type != 'default') this.active_index = []
      else this.active_index = [this.listArr.list[0].id]
    },
    list_toggle(item) {
      let index = this.active_index.findIndex(id => id == item.id)
      let dom = document.querySelector(`#flod_text_content_${item.id}`)
      if (index == -1 ) {
        if (this.pcWidgetsInfor.show_type != 'default') {
          this.active_index.push(item.id)
        } else {
          let id = this.active_index[0]
          this.active_index.splice(0, 1, item.id)
          document.querySelector(`#flod_text_content_${id}`).style.height = '0px'
        }
        dom.style.height = `${dom.getAttribute('data-height')}`
        
      } else {
       
        if (this.pcWidgetsInfor.show_type != 'default') {
          this.active_index.splice(index, 1)
          dom.style.height = '0px'
        }
       
      }

    },
    getFaqDom(idx) {
      const ref = this.$refs[`faqAnswer_${idx}`]
      return Array.isArray(ref) ? ref[0] : ref
    },
    // 展开(true)/收起(false) 指定FAQ项，带高度过渡动画
    setFaqHeight(idx, expand) {
      const dom = this.getFaqDom(idx)
      if (!dom) return
      if (expand) {
        dom.style.height = dom.scrollHeight + 'px'
        const onEnd = (e) => {
          if (e.propertyName !== 'height') return
          // 动画结束后置为auto，兼容内容异步变化（如图片加载）
          dom.style.height = 'auto'
          dom.removeEventListener('transitionend', onEnd)
        }
        dom.addEventListener('transitionend', onEnd)
      } else {
        // 从auto收起时先固定高度，强制回流后再归零，保证过渡平滑
        dom.style.height = dom.scrollHeight + 'px'
        void dom.offsetHeight
        dom.style.height = '0px'
      }
    },
    // 默认展开第一项
    initFaqActive() {
      this.activeFaqIndex = 0
      this.$nextTick(() => {
        const dom = this.getFaqDom(0)
        if (dom) dom.style.height = 'auto'
      })
    },
    faqToggle(idx) {
      if (this.activeFaqIndex === idx) {
        // 再次点击当前项则收起
        this.setFaqHeight(idx, false)
        this.activeFaqIndex = -1
        return
      }
      // 收起上一个已展开项
      if (this.activeFaqIndex > -1) {
        this.setFaqHeight(this.activeFaqIndex, false)
      }
      this.activeFaqIndex = idx
      this.$nextTick(() => {
        this.setFaqHeight(idx, true)
      })
    },
    fetchFaqData() {
      const id = this.$route.query.id
      if (!id) return
      let promise = null
      // 根据当前页面类型调用不同接口
      if (this.$route.name === 'product') {
        promise = getGoodsEdit({ id })
      } else if (this.$route.name === 'article') {
        promise = getArticleEdit({ id })
      }
      if (!promise) return
      promise.then(res => {
        if (res.code === 200 && res.data.info && res.data.info.faq) {
          try {
            const parsed = JSON.parse(res.data.info.faq)
            // 只有接口返回了有效数组且有数据才覆盖默认值
            if (Array.isArray(parsed) && parsed.length > 0) {
              this.fetchedFaqList = parsed
              // 数据更新后重新默认展开第一项
              this.$nextTick(() => {
                this.initFaqActive()
              })
            }
          } catch(e) {
            console.warn('[折叠文本列表] FAQ数据解析失败', e)
          }
        }
      }).catch(err => {
        console.warn('[折叠文本列表] 获取FAQ数据失败', err)
      })
    },
    height_set() {
      this.$nextTick(() => {
        this.listArr.list.forEach(item => {
          let dom = document.querySelector(`#flod_text_content_${item.id}`)
          let height = dom.querySelector('.content-text').offsetHeight ? dom.querySelector('.content-text').offsetHeight : dom.querySelector('.content-text').offsetHeight
          dom.setAttribute('data-height', `${height}px`)
          if (dom.classList.contains('flod_content_height_auto')) {
            dom.style.height = `${height}px`
          } else  dom.style.height = '0px'
        })
      })
      
    }
  }
};
</script>

<style scoped lang="scss">
.basic_flod_text_list{
  .list-wrap{
    .flod-list{
      position: relative;
      .flod_text_title{
        padding: 16px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .title-left{
          flex: 1;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .title-icon{
          max-width: 100%;
          max-height: 100%;
          object-fit: cover;
        }
      }
      .flod_text_content{
         transition: all 1s;
         overflow: hidden;
         padding: 0 20px;
        &.flod_content_height_auto{
          height:auto;
        }
        &.flod_content_height_0{
          height:0;
        }
      }
    }
    .flod-list-show{
      .title-default{
        display: none;
      }
      .title-hover{
        display:block
      }
    }
    .flod-list-hidden{
      .title-default{
        display: block;
      }
      .title-hover{
        display:none
      }
    }
    // FAQ样式
    .faq-preview-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 20px;
      color: #909399;
      font-size: 14px;
      i {
        font-size: 32px;
        margin-bottom: 10px;
      }
    }
    .faq-list {
      .faq-item {
        border-bottom: 1px solid #eee;
        &:last-child {
          border-bottom: none;
        }
        .faq-item-title {
          display: flex;
          align-items: center;
          padding: 16px 20px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          &:hover {
            background-color: rgba(0, 0, 0, 0.02);
          }
          .faq-question {
            flex: 1;
            font-size: 15px;
            font-weight: 500;
            color: #333;
            line-height: 1.5;
            transition: color 0.3s ease;
          }
          .title-icon {
            flex-shrink: 0;
            margin-left: 12px;
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
          }
          .title-default {
            display: block;
          }
          .title-hover {
            display: none;
          }
          .faq-toggle-icon {
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            margin-left: 12px;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10z' fill='%23999'/%3E%3C/svg%3E");
            background-size: contain;
            background-repeat: no-repeat;
            transition: transform 0.3s ease;
          }
        }
        &.is-active {
          .faq-item-title {
            .faq-question {
              color: #0078d7;
            }
            .title-default {
              display: none;
            }
            .title-hover {
              display: block;
            }
            .faq-toggle-icon {
              transform: rotate(180deg);
            }
          }
        }
        .faq-answer-wrap {
          overflow: hidden;
          height: 0;
          transition: height 0.3s ease;
          .faq-answer {
            padding: 0 20px 16px;
            font-size: 14px;
            color: #666;
            line-height: 1.7;
            img {
              max-width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_flod_text_list/index.vue